import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetAllActivities } from '../models/getallactivities';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EventviewService {
  constructor(private http: HttpClient) {}
  getAllActivities(): Observable<GetAllActivities[]> {
    return this.http.get<GetAllActivities[]>('assets/json/getallactivities.json');
    //return this.http.get<GetAllActivities[]>(this.activitiesUrl+'TeamMembers/getAllActivities')
  }
}
